const DEFAULT_RETRIES = 3;
const DEFAULT_INITIAL_DELAY = 500;

const imageReloadFactory = (imageUrl, retries = DEFAULT_RETRIES, delay = DEFAULT_INITIAL_DELAY) => {
  const imageReload = (e) => {
    const image = e.target;
    if (retries > 0) {
      setTimeout(() => {
        image.src = `${imageUrl}?${Date.now()}${retries}`;
      }, delay);
      retries -= 1;
      delay *= 2;
    }
  };
  return imageReload;
};

export default imageReloadFactory;
